import React from 'react'
import page from 'page'

export default ({ to, className, onClick, children }) => {
  function handleClick (e) {
    e.preventDefault()
    onClick && onClick()
    to && page(to)
  }

  return (
    <a href={to} className={className} onClick={handleClick}>{children}</a>
  )
}



// WEBPACK FOOTER //
// ./src/components/Link.jsx